@use '@/styles/tokens' as *;

// Figma node 232:355195 — 54px disc, 22px Power glyph, 17px inset.

.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 54px;
  height: 54px;
  padding: 0;
  border-radius: 50%;
  cursor: pointer;
  transition:
    filter 150ms ease,
    background 150ms ease;

  &:focus-visible {
    outline: none;
    box-shadow: var(--focus-ring);
  }

  &:disabled {
    cursor: default;
  }
}

// The Device Details cluster's disc, which the design draws larger than the card's (Figma
// 219:340859: ~60px inside a 75px backing circle, against the card's 54px).
.large {
  width: 60px;
  height: 60px;
}

// Lit: a radial gradient running from the paler accent1-400 at the centre out to the saturated
// accent1-500 at the rim.
//
// The direction matters and used to be inverted. This previously faded from transparent at the
// centre to an **opaque** `#F7FCBE` at the rim over an accent1-400 base — palest exactly where the
// design is strongest — which is what made the disc read as a washed-out cream rather than the
// design's lime. Sampled 1:1 off Figma node 232:355173: centre `#F3FE71` (accent1-400, Δ=8.1),
// rim `#EBFB38`. That rim sits between accent1-500 and -600 and matches no stop exactly;
// accent1-500 is the nearest (Δ=32.8) and is used rather than adding a ramp entry for one disc.
.energised {
  border: 0.5px solid $color-accent1-300;
  // The stop lands at 45%, not 100%: sampling the design shows the saturated tone covering most
  // of the disc's *area* with only a small pale core, so a gradient that reached full saturation
  // only at the outer edge still read too pale across the mid-band.
  background: radial-gradient(
    circle 27px at 50% 50%,
    $color-accent1-400 0%,
    $color-accent1-500 45%
  );
  box-shadow:
    0 1px 1.5px $color-power-shade,
    inset 0 1px 3px $color-power-rim;

  &:hover:not(:disabled) {
    filter: brightness(1.03);
  }
}

.muted {
  border: none;
  background: $color-neutral-200;
}

// `neutral-700`, not `-600`: the glyph samples at `#545454` on the off disc (Δ=1.7 from
// neutral-700's `#555555`) and darker still on the lit one. `neutral-600`'s `#777777` was ~60 away
// and read as a faded grey against both fills.
.icon {
  color: $color-neutral-700;
}
